import { httpClient, httpClientUrlStringBuilder } from '@/network/clientController'

/** Get Batchfile Transfers List
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_batchfilesearch
*/
export const requestBatchfileTransfersList = payload => {
	return httpClient({
		method: 'GET',
		url: 'batchfile/search',
        params: payload,
		isCancellable: true
	})
}

/** Get Batchfile Files Types List
@docs Não há documentação
*/
export const requestBatchfileFilesTypes = payload => {
	return httpClient({
		method: 'GET',
		url: 'batchfile/entries/fileTypes',
		isCancellable: true
	})
}

/** Get Batchfile Operation Types List
@docs Não há documentação
*/
export const requestBatchfileOperationTypes = payload => {
	return httpClient({
		method: 'GET',
		url: 'batchfile/entries/operationTypes',
		isCancellable: true
	})
}

/** Get Batchfile Transaction Types List
@docs Não há documentação
*/
export const requestBatchfileTransactionTypes = payload => {
	return httpClient({
		method: 'GET',
		url: 'batchfile/entries/transactionTypes',
		isCancellable: true
	})
}

/** Get Batchfile Motives List
@docs Não há documentação
*/
export const requestBatchfileMotives = payload => {
	return httpClient({
		method: 'GET',
		url: 'batchfile/entries/motives',
		isCancellable: true
	})
}

/** Get Batchfile Categories List
@docs Não há documentação
*/
export const requestBatchfileCategories = payload => {
	return httpClient({
		method: 'GET',
		url: 'batchfile/entries/categories',
		isCancellable: true
	})
}

/** Get Batchfile Transfer Detail
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_batchfile%7Bid%7D
*/
export const requestBatchfileTransferDetail = payload => {
	return httpClient({
		method: 'GET',
		url: `batchfile/${payload}`,
		isCancellable: true
	})
}

/** Get Iban Information
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_transferstypedestination
*/
export const requestIbanInformation = payload => {
	return httpClient({
		method: 'GET',
		url: 'transfers/type/iban',
		params: payload
	})
}

/** Submit Batchfile xls
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_batchfilesubmit
*/
export const submitBatchfileXLS = payload => {
	return httpClient({
		method: 'POST',
		url: 'batchfile/submit',
		data: payload
	})
}

/** Submit Manual BatchFile Header
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_batchfilesubmitManualHeader
*/
export const submitManualBatchFileHeader = payload => {
	return httpClient({
		method: 'POST',
		url: 'batchfile/submitManualHeader',
		data: payload
	})
}

/** Submit Manual BatchFile Entries
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_batchfilesubmitManualBatchFileEntries
*/
export const submitManualBatchFileEntries = payload => {
	return httpClient({
		method: 'POST',
		url: 'batchfile/submitManualBatchFileEntries',
		data: payload
	})
}

/** -Approve Batchfile
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_batchfile%7Bid%7Dapprove
*/
export const aproveBatchfile = payload => {
	return httpClient({
		method: 'POST',
		url: `batchfile/${payload.id}/approve`,
		data: {},
		operationTypeId: 701 /* for mocks handling of tokens */
	})
}

/** Sends a Batchfile operation notification to email
@docs Não há documentação
*/
export const sendBatchfileEmailNotification = payload => {
	return httpClient({
		method: 'POST',
		url: `batchfile/${payload.id}/notification/email`,
		data: payload.data
	})
}

/** Sends a Batchfile operation notification to sms
@docs Não há documentação
*/
export const sendBatchfileSMSNotification = payload => {
	return httpClient({
		method: 'POST',
		url: `batchfile/${payload.id}/notification/sms`,
		data: payload.data
	})
}

/** Create Batchfile Download Receipt Url
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_batchfile%7Bid%7Dreceipt
*/
export const createBatchfileDownloadReceiptUrl = payload => {
	return httpClientUrlStringBuilder({
		method: 'GET',
		url: `batchfile/${payload}/receipt`
	})
}

/** Send Batchfile XLS email
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_batchfile%7Bid%7Demail
*/
export const sendBatchfileXLSEmail = payload => {
	return httpClient({
		method: 'POST',
		url: `batchfile/${payload.batchFileId}/email`,
		data: payload.data
	})
}

/** Create Batchfile XLS Download Url
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_batchfile%7Bid%7Ddownload
*/
export const createBatchfileExcelDownloadUrl = payload => {
	return httpClientUrlStringBuilder({
		method: 'GET',
		url: `batchfile/${payload}/download`
	})
}

/** Sends a Batchfile operation notification to email for entry in batchfile lines
@docs Não há documentação
*/
export const sendBatchfileEntryEmailNotification = payload => {
	return httpClient({
		method: 'POST',
		url: `batchfile/${payload.id}/sequence/${payload.sequence}/notification/email`,
		data: payload.data
	})
}

/** Sends a Batchfile operation notification to sms for entry in batchfile lines
@docs Não há documentação
*/
export const sendBatchfileEntrySMSNotification = payload => {
	return httpClient({
		method: 'POST',
		url: `batchfile/${payload.id}/sequence/${payload.sequence}/notification/sms`,
		data: payload.data
	})
}

/** Create Batchfile Download Receipt Url for entry in batchfile lines
@docs Não há documentação
*/
export const createBatchfileEntryDownloadReceiptUrl = payload => {
	return httpClientUrlStringBuilder({
		method: 'GET',
		url: `batchfile/${payload.id}/sequence/${payload.sequence}/receipt`
	})
}

/** Create Batchfile XLS Download Url
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_batchfilestatuses
*/
export const requestBatchfilStatus = payload => {
	return httpClient({
		method: 'GET',
		url: 'batchfile/statuses'
	})
}
